export const contentTableConfig = {
  title: '资源列表',
  propList: [
    {
      prop: 'uname',
      label: '客户昵称',
      minWidth: '220',
      slotName: 'consumer',
      align: 'left'
    },
    { prop: 'uid', label: '客户ID', minWidth: '80', align: 'left' },
    { prop: 'unionid', label: 'UnionID', minWidth: '80', align: 'left' },
    { prop: 'sid', label: '账号ID', minWidth: '80', align: 'left' },
    { prop: 'sname', label: '账号名称', minWidth: '100', align: 'left' },
    { prop: 'usedBy', label: '使用人', minWidth: '80', align: 'left' },
    { prop: 'corpName', label: '主体名称', minWidth: '120', align: 'left' },
    { prop: 'corpId', label: '主体ID', minWidth: '100', align: 'left' },
    { prop: 'groupName', label: '所属组', minWidth: '80', align: 'left' },
    { prop: 'sourceLabel', label: '来源渠道', minWidth: '80', align: 'left' },
    { prop: 'thirdParty', label: '所属第三方', minWidth: '80' },
    {
      prop: 'createdAt',
      label: '加入时间',
      minWidth: '80',
      align: 'left'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
